import React from 'react';
import PanelCollapse from 'src/componentes/panel-collapse';

const defaultCardStyle = {
  marginLeft: 0,
  marginRight: 0,
  marginBottom: 24,
  padding: 16,
};

const defaultStyleTitle = {
  fontSize: 16,
  fontWeight: 700,
  color: '#09090B',
};

// Um bloco colapsável (accordion) para uso dentro de modais de edição.
// Encapsula o PanelCollapse com margens, padding e tipografia de título iguais 

function ModalFormCollapsibleSection({
  header,
  children,
  open = false,
  collapsible = true,
  style,
  styleTitle,
  ...rest
}) {
  return (
    <PanelCollapse
      open={collapsible ? open : true}
      collapsible={collapsible}
      header={header}
      headerStyle="font-weight-bolder"
      style={{ ...defaultCardStyle, ...style }}
      noPadding
      styleTitle={{ ...defaultStyleTitle, ...styleTitle }}
      contentMarginTop={16}
      {...rest}
    >
      {children}
    </PanelCollapse>
  );
}

export default ModalFormCollapsibleSection;
